import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './quasar'
import './styles/app.scss'
import moment from 'moment'
import HighchartsVue from 'highcharts-vue'
import Highcharts from 'highcharts'
import VueCurrencyInput from 'vue-currency-input'
import VueMeta from 'vue-meta'
import capitalizeFirstLetter from "@/helper/capitalizeFirstLetter";
import money from 'v-money'
import VueLuzmoDashboard from "@luzmo/vue-embed/vue2";

const pluginOptions = {
  /* see config reference */
  globalOptions: { currency: 'USD', allowNegative: false }
}
Vue.use(VueCurrencyInput, pluginOptions)
Vue.use(VueMeta)
Vue.use(money, {precision: 2})
Vue.use(VueLuzmoDashboard);

Highcharts.setOptions({
  lang: {
    thousandsSep: ','
  }
})

const url = window.location.href
const tokenQuery = url.split('?token=')
if (tokenQuery.length > 1) {
  const token = tokenQuery[1]
  localStorage.setItem('token', `Bearer ${token}`)
  window.location.href = '/'
}

Vue.use(HighchartsVue)
Vue.config.productionTip = false
router.beforeEach((to, from, next) => {
  const publicPages = [
    `/login`,
    `/login-tsd`,
    `/forgot-password`,
    `/reset-password/:token`,
    `/demo`,
    `/demo-account-request/:id`,
    `/invoice/:id`,
    `/oauth2`,
    `/oauth2/:provider`
  ]

  const isPublic = publicPages.some((page) => to.matched.some((record) => record.path === page))
  const isAuth = localStorage.getItem('token')

  if (!isPublic && !isAuth) {
    next(`/login`)
  } else {
    next()
  }
})

Vue.filter('createdFormat', value => {
  return moment(value).format('l')
})

Vue.filter('dateFormat', value => {
  return moment(value).format('M.D.YYYY')
})

Vue.filter('dateTimeFormat', value => {
  return moment(value).format('M.D.YYYY h:mm:ss A')
})

Vue.filter('toCurrency', function (value) {
    if (typeof value !== "number") {
        return value;
    }

    const formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD'
    });
    return formatter.format(value);
});

Vue.filter('capitalizeFirstLetter', function (value) {
  return capitalizeFirstLetter(value);
});

Vue.filter('numberWithCommas', function (value) {
    return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
});

Vue.filter('formatPrice', function (value) {
    if (value === null) return '-'

  try {
    return value.toLocaleString('en-US', {
        style: 'currency',
        currency: 'USD'
    })
  } catch (e) {
    return '-'
  }
});

Vue.filter('formatNumber', function (value) {
    if (value === null) return '-'

    return value.toLocaleString()
});

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
